import { palette } from './palette';
import {
  TTheme,
  TThemeBorderRadius,
  TThemeFonts,
  TThemeFontSizes,
  TThemeShadow,
  TThemeSpacing,
  TThemeZIndex,
} from './theme.types';

export type { TTheme } from './theme.types';

const spacing: TThemeSpacing = {
  none: 0,
  xxs: 2,
  xs: 4,
  s: 8,
  sm: 12,
  m: 16,
  ml: 20,
  l: 24,
  xl: 32,
  xxl: 40,
  xxxl: 48,
};

const borderRadius: TThemeBorderRadius = {
  none: 0,
  xs: 4,
  s: 6,
  sm: 8,
  m: 12,
  l: 16,
  xl: 24,
  device: 22,
  pill: 999,
};

const fonts: TThemeFonts = {
  regular: "'Inter', system-ui, sans-serif",
  semiBold: "'Inter', system-ui, sans-serif",
  bold: "'Inter', system-ui, sans-serif",
};

const fontSizes: TThemeFontSizes = {
  xxs: 10,
  xs: 11,
  s: 12,
  m: 14,
  l: 16,
  xl: 20,
  xxl: 28,
};

const zIndex: TThemeZIndex = {
  base: 0,
  canvasElement: 10,
  panel: 100,
  header: 200,
  popover: 300,
  modal: 400,
};

const darkShadow: TThemeShadow = {
  panel: '0 0 0 1px rgba(255, 255, 255, 0.04)',
  card: '0 4px 16px rgba(0, 0, 0, 0.4)',
  menu: '0 8px 24px rgba(0, 0, 0, 0.35)',
  elevated: '0 12px 32px rgba(0, 0, 0, 0.55)',
  device: '0 24px 80px rgba(0, 0, 0, 0.6)',
  knob: '0 1px 2px rgba(0, 0, 0, 0.3)',
};

export const darkTheme: TTheme = {
  colors: {
    backgroundPrimary: palette.ink900,
    backgroundSecondary: palette.ink800,
    backgroundTertiary: palette.ink700,
    surface: palette.ink600,
    surfaceHover: palette.ink500,
    textPrimary: palette.white,
    textSecondary: palette.grey300,
    textMuted: palette.grey400,
    primary: palette.teal500,
    primaryHover: palette.teal400,
    onPrimary: palette.ink900,
    danger: palette.red500,
    dangerHover: palette.red400,
    dangerSurface: palette.red600,
    dangerSurfaceHover: palette.red700,
    onDanger: palette.white,
    warning: palette.amber400,
    selection: palette.cyan400,
    scrimSubtle: 'rgba(0, 0, 0, 0.22)',
    scrimSoft: 'rgba(0, 0, 0, 0.35)',
    scrimMedium: 'rgba(0, 0, 0, 0.55)',
    scrimStrong: 'rgba(0, 0, 0, 0.75)',
    scrimHeavy: 'rgba(0, 0, 0, 0.85)',
    guideLine: 'rgba(255, 255, 255, 0.4)',
    deviceScreen: palette.black,
    border: palette.ink400,
    borderSubtle: palette.ink500,
    borderStrong: palette.ink200,
    overlay: 'rgba(0, 0, 0, 0.6)',
    canvas: palette.canvasDark,
  },
  spacing,
  borderRadius,
  shadow: darkShadow,
  fonts,
  fontSizes,
  zIndex,
};
